import { connect } from 'react-redux';
import AuthenticateComponent from '../components/common/AuthenticateComponent';

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticateComponent);
